import { setItem } from "@/lib/utils";
import AuthService from "@/services/api/auth/auth";

import {
  createAsyncThunk,
  createSlice,
} from "@reduxjs/toolkit";

interface LayoutConfigState {
  config: any;
  isFetching: boolean;
  loading: boolean;
  error: string | null;
}

const savedConfig = localStorage.getItem("layoutConfig");

const initialState: LayoutConfigState = {
  config: savedConfig ? JSON.parse(savedConfig) : null,
  isFetching: false,
  loading: false,
  error: null,
};

export const getLayoutConfig = createAsyncThunk(
  "layoutConfig/getLayoutConfig",
  async (_: void, { rejectWithValue }) => {
    try {
      const response = await AuthService.webAppSetting();
      setItem("layoutConfig", response);
      document.title = response?.WebAppTitle;
      return response
    } catch (err: any) {
      return rejectWithValue(
        err?.Message || "Failed to fetch layout config"
      );
    }
  }
);

const layoutConfigSlice = createSlice({
  name: "layoutConfig",
  initialState,

  reducers: {
    clearLayoutConfig: (state) => {
      state.config = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getLayoutConfig.pending, (state) => {
        state.loading = true;
      })
      .addCase(getLayoutConfig.fulfilled, (state, action) => {
        state.config = action.payload;
        document.title = action.payload?.WebAppTitle || document.title;
      })
      .addCase(getLayoutConfig.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string || "Something went wrong";
      });
  },
});

export const { clearLayoutConfig } = layoutConfigSlice.actions;
export default layoutConfigSlice.reducer;
